import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import HttpBase from '../models/httpBase';
import EnvironmentService from '../services/environmentService';
import ComplianceAuditLog from '../models/complianceAuditLog';

@Injectable()
export default class ComplianceAuditLogService extends HttpBase {
  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }

  addComplianceAuditLogs(complianceAuditLogs: ComplianceAuditLog[]): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.httpPost(this.environmentService.complianceAuditLogs, complianceAuditLogs)
      .subscribe((r: Response) => {
        if (r.status === 200) {
          resolve(true);
        } else {
          reject(false);
        }
      });
    });
  }
}




// WEBPACK FOOTER //
// ./src/services/complianceAuditLogService.ts